// @ai-generated 2026-08-27T12:28:10+00:00 by malte.ulfers@tngtech.com using Claude Opus 5
import { usePermissionsRepository } from '@Hooks/useRepository';
import { OwnProfileRepository } from '@Repositories/Permissions';
import { useMutation } from '@tanstack/react-query';

/**
 * Accept the partnership a user was invited into, unlocking it for them.
 */
export const useAcceptPartnership = () => {
    const ownProfile = usePermissionsRepository(OwnProfileRepository);

    return useMutation({
        mutationFn: (partnershipId: string) => ownProfile.acceptPartnership(partnershipId),
    });
};

/**
 * Refuse the partnership a user was invited into, deleting their user account in it.
 */
export const useRejectPartnership = () => {
    const ownProfile = usePermissionsRepository(OwnProfileRepository);

    return useMutation({
        mutationFn: (partnershipId: string) => ownProfile.rejectPartnership(partnershipId),
    });
};
